/* eslint-disable react/jsx-pascal-case */
import React, { useCallback, useEffect, useState } from 'react'
import { TableVirtuoso } from 'react-virtuoso'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableBody from '@material-ui/core/TableBody'
import O_TableBar from 'components/3_Organisms/O_TableBar'
import O_TableHeaderUserSummary from 'components/3_Organisms/O_TableHeaderUserSummary'
import O_TableRowUserSummary from 'components/3_Organisms/O_TableRowUserSummary'
import { useButtons, useCheckList, useSearchedFormat } from 'hooks/useUserTorokuTable'
import { useChangeTableHeight, useChangeInnerHeight } from 'hooks/useCommon'
import { voidF } from 'types/FunctionTypes'
import { responseUser } from 'utils/requestUtil'
import { isUniqueUser } from 'utils/booleanUtil'
import { useLoading } from 'hooks/usePage'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
    },
    container: {
      maxHeight: 600,
    },
    isEmptyName: {
      height: 30,
      backgroundColor: '#FFD1E0',
    },
    isSelectedEmptyName: {
      height: 30,
      '&:not(:hover)': {
        backgroundColor: '#FFA8C5',
      },
    },
  }),
)

type Props = {
  userList: responseUser[]
  isFetching: boolean
  refetch: voidF
}

const O_TableUser = ({ userList, isFetching, refetch }: Props) => {
  const classes = useStyles()
  const [loding, changeLoading] = useLoading()
  useEffect(() => {
    if (isFetching) {
      changeLoading(true)
    }
    if (!isFetching && loding) {
      changeLoading(false)
    }
  }, [isFetching])
  const [checkListJoken, allCheck] = useCheckList(userList)
  const buttonInfos = useButtons(refetch)
  const [selectList, searchedFormat] = useSearchedFormat()

  const isAllChecked = userList.length === 0 ? false : userList.length === checkListJoken.length
  const [tableHeight, setTableHeight] = useState(window.innerHeight)
  const [currentInnerHeight, setCurrentInnerHeight] = useState(window.innerHeight)
  const [previousInnerHeight, setPreviousInnerHeight] = useState(window.innerHeight)
  const [changeTableHeight] = useChangeTableHeight(tableHeight, currentInnerHeight, previousInnerHeight, setTableHeight)
  const [changeInnerHeight] = useChangeInnerHeight(currentInnerHeight, setCurrentInnerHeight, setPreviousInnerHeight)
  useEffect(() => {
    // ウィンドウサイズ変更時にchangeInnerHeightを呼び出すようにリスナーに登録
    window.removeEventListener('resize', changeInnerHeight)
    window.addEventListener('resize', changeInnerHeight)
    return () => {
      window.removeEventListener('resize', changeInnerHeight)
    }
  }, [window.innerHeight, currentInnerHeight])
  useEffect(() => {
    // useEffectが呼ばれるのはウィンドウサイズを変えたとき、スクロール含めた高さが変わったとき（初期表示時にも調整するため）
    // ウィンドウサイズを変えると上記2パターンに引っ掛かり2回動くので
    // changeTableHeightを呼ぶのはcurrentInnerHeightを更新した後のみにする
    if (currentInnerHeight === window.innerHeight) changeTableHeight()
  }, [document.documentElement.scrollHeight, currentInnerHeight])

  const getChecked = (user: responseUser) => (isAllChecked ? true : checkListJoken.length <= 0 ? false : checkListJoken.some((r) => isUniqueUser(r, user)))
  const table = (props: any) => <Table {...props} style={{ borderCollapse: 'separate' }} size="small" aria-label="purchases" />
  const tableRow = (props: any) => <TableRow hover role="checkbox" {...props} className={clsx({ [classes.isSelectedEmptyName]: props.item.NAME.trim() === '' && getChecked(props.item), [classes.isEmptyName]: props.item.NAME.trim() === '' })} selected={getChecked(props.item)} />
  const getComponent = useCallback(() => {
    return {
      Scroller: TableContainer,
      Table: table,
      TableHead: TableHead,
      TableRow: tableRow,
      TableBody: TableBody,
    }
  }, [checkListJoken.length])

  if (isFetching) {
    if (selectList.length > 0) searchedFormat()
    return <div>検索中...</div>
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item style={{ width: '100%' }}>
          <O_TableBar count={userList.length} buttonInfos={buttonInfos} />
        </Grid>
        <Grid item style={{ width: '100%' }}>
          <TableVirtuoso
            style={{ height: tableHeight }} // 仮想リスト(表示範囲400以降はスクロール毎に描画する)
            data={userList}
            components={getComponent()}
            fixedHeaderContent={() => <O_TableHeaderUserSummary click={allCheck} isChecked={isAllChecked} />}
            itemContent={(_, user) => <O_TableRowUserSummary user={user} isChecked={getChecked(user)} />}
          />
        </Grid>
        <Grid item style={{ width: '100%' }}>
          <O_TableBar count={userList.length} buttonInfos={buttonInfos} />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(O_TableUser)
